// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1PZUG","insightsList":"newBusinessInsightsMenu_insightsList__1aWyd","active":"newBusinessInsightsMenu_active__iZPAD"};